
import Authority from '../components/Authority/Authority';
import Hero from '../components/Hero/Hero';
import Services from '../components/Services/Services';
import Value from '../components/Value/Value';

import CTA from '../components/CTA/CTA';

const Home = () => (
  <>
    <Hero />
    <Authority />
    <Services />
    <Value />
    <CTA />
  </>
);

export default Home;
